module.exports = __webpack_public_path__ + "img/phone3-icon.429ac78e.png";